import { get } from 'lodash'

import { emeaCountries, lacarCountries } from '../configuration/countryCodes'

/**
 * Determines which promotional qualifiers should be displayed based on the SSO
 * agent's country and the selected brand/ship.
 *
 * Rules:
 *  - EMEA agent + Royal (or the All-brands / no-ship default): show only Age 55+.
 *  - EMEA agent + Celebrity selection: show no qualifiers.
 *  - LACAR agent: show no qualifiers, regardless of brand.
 *  - All other agents (USA/CAN): gated solely by allowSpecialQualifiers.
 */
export const getPromotionalQualifierVisibility = ({
  agentCountry,
  allowSpecialQualifiers,
  activeSearchFilterData,
  ships
}) => {
  const normalizedAgentCountry = (agentCountry || '').toUpperCase()
  const isEmeaAgent = emeaCountries.includes(normalizedAgentCountry)
  const isLacarAgent = lacarCountries.includes(normalizedAgentCountry)

  const brand = get(activeSearchFilterData, 'brand')
  const selectedShipCode = get(activeSearchFilterData, 'ship')
  const selectedShip =
    ships && selectedShipCode
      ? ships.find(ship => ship.ship_code === selectedShipCode)
      : null
  const selectedShipBrand = selectedShip ? selectedShip.brand_code : null
  const isCelebritySelection = brand === 'C' || selectedShipBrand === 'C'

  let showSeniorCitizen = allowSpecialQualifiers
  let showServiceQualifiers = allowSpecialQualifiers

  if (isEmeaAgent) {
    // RULE: Celebrity hides everything; Royal / All-brands default shows only Age 55+.
    showSeniorCitizen = !isCelebritySelection
    showServiceQualifiers = false
  } else if (isLacarAgent) {
    // RULE: LACAR agents never see qualifiers, regardless of brand.
    showSeniorCitizen = false
    showServiceQualifiers = false
  }

  return {
    showSeniorCitizen,
    showServiceQualifiers,
    showQualifiers: showSeniorCitizen || showServiceQualifiers
  }
}

export default getPromotionalQualifierVisibility
